import { Outlet } from "@tanstack/react-router";
import { AuthProvider } from "../lib/contexts/auth-context";

export default function RootRoute() {
	return (
		<div id="root-route-component">
			<AuthProvider>
				<Outlet />
			</AuthProvider>
		</div>
	);
}
